var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bcc-nav-slider-item__wrap",class:{'is-active': _vm.active},on:{"click":_vm.clickItem}},[_c('div',{staticClass:"bcc-nav-slider-item__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }